var _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMissionTen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 70,
    viewBox: "0 0 49 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7393 4.21646C16.0401 4.42908 15.6457 5.16823 15.8583 5.8674L19.3231 17.2611C19.5357 17.9602 20.2749 18.3547 20.9741 18.142C21.6732 17.9294 22.0677 17.1903 21.855 16.4911L18.7752 6.3634L28.9029 3.28355C29.602 3.07093 29.9965 2.33178 29.7839 1.63261C29.5712 0.93344 28.8321 0.539011 28.1329 0.751631L16.7393 4.21646ZM30.935 32.1545L31.2061 33.4496L30.935 32.1545ZM16.5013 6.64981C23.111 10.1769 31.565 15.6591 35.7841 20.6914C37.9477 23.2719 38.6325 25.2957 38.1556 26.7293C37.6843 28.1458 35.8055 29.7832 30.6639 30.8593L31.2061 33.4496C36.4572 32.3506 39.7063 30.4511 40.6667 27.5647C41.6213 24.6954 40.0414 21.6501 37.8121 18.9912C33.2456 13.5446 24.4016 7.86596 17.7472 4.31503L16.5013 6.64981ZM30.6639 30.8593C24.1071 32.2317 19.7388 34.1634 17.3636 36.7069C16.1459 38.0108 15.4494 39.4796 15.2772 41.0753C15.107 42.6522 15.4595 44.2486 16.1589 45.8144C17.5415 48.9099 20.3896 52.1265 23.9804 55.32C27.5971 58.5365 32.0839 61.83 36.8861 65.0603L38.3632 62.8645C33.6056 59.6642 29.2288 56.4461 25.7391 53.3425C22.2236 50.216 19.7227 47.3041 18.5752 44.7351C18.0095 43.4685 17.8015 42.3486 17.9083 41.3593C18.0131 40.3887 18.431 39.4413 19.2978 38.5131C21.0914 36.5924 24.7721 34.7963 31.2061 33.4496L30.6639 30.8593Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.69011,
    cy: 27.5173,
    r: 5.92745,
    stroke: "white",
    strokeWidth: 2.64641
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.694,
    cy: 45.2585,
    r: 5.92745,
    stroke: "white",
    strokeWidth: 2.64641
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6471,
    cy: 61.8044,
    r: 5.92745,
    stroke: "white",
    strokeWidth: 2.64641
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissionTen);
export default __webpack_public_path__ + "static/media/iconMissionTen.c9cbd11a84c54cefcc37cea41781bf09.svg";
export { ForwardRef as ReactComponent };